import { useApplicationFieldVisibility } from "@Client/@Composables/application-standalone/useApplicationFieldVisibility";
import { useFillOutVisibility } from "@Client/@Composables/application-standalone/useFillOutVisibility";
import { APPLICATION_STEPS } from "@Client/@Utils/enums";
import { computed } from "@vue/composition-api";
export const useMortgageDetailsFieldVisibility = () => {
  const {
    computeSchemaVisibility
  } = useApplicationFieldVisibility();
  const {
    computeFillOutVisibility
  } = useFillOutVisibility();
  const rootPath = computed(() => "[mortgage-details]");
  const mortgageDetailsClosingDateVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPath.value + "[mortgage-details][closing-date]");
    const visibleFromFillOut = computeFillOutVisibility(APPLICATION_STEPS.GOALS, {
      path: rootPath.value + "[mortgage-details][closing-date]"
    });
    return visibleFromSchema.value && visibleFromFillOut.value;
  });
  const mortgageDetailsDownpaymentAmountVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPath.value + "[down-payment][amount]");
    const visibleFromFillOut = computeFillOutVisibility(APPLICATION_STEPS.GOALS, {
      path: rootPath.value + "[down-payment][amount]"
    });
    return visibleFromSchema.value && visibleFromFillOut.value;
  });
  return {
    mortgageDetailsClosingDateVisible,
    mortgageDetailsDownpaymentAmountVisible
  };
};